import types from '../../types/types';

const initialState = {};

const departmentsAndMunicipalitiesReducer = ( state = initialState, action: any ) => {

    switch ( action.type ) {
        
        case types.saveDepartmentsAndMunicipalities:
            return {
                ...state,
                ...action.payload
            }

        default:
            return state;

    }

}

export default departmentsAndMunicipalitiesReducer;

